export const ALL_MONTHS = ["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];

export const TAB_COLOR = {
  dashboard:"#2D7A2D", revenue:"#2255AA", expenses:"#C0392B",
  salary:"#AA7722", transport:"#AA7722", actuals:"#553399",
  cashflow:"#1A7A7A", loans:"#1A5A8A", settings:"#666",
};

export const DEFAULT_EXPENSE_ITEMS = [
  {id:"officer",   label:"役員報酬", auto:false },
  {id:"salary",    label:"給料",     auto:true,  autoKey:"salary" },
  {id:"bonus",     label:"賞与",     auto:true,  autoKey:"bonus"  },
  {id:"transport", label:"交通費",   auto:true,  autoKey:"transport"},
  {id:"insurance",     label:"社会保険", auto:true,  autoKey:"insurance"},
  {id:"loan_interest", label:"借入利息", auto:true,  autoKey:"loanInterest"},
  {id:"outsource",     label:"外注費",   auto:false},
  {id:"office",    label:"事務所",   auto:false},
  {id:"entertain", label:"交際費",   auto:false},
  {id:"other",     label:"その他経費",auto:false},
];

export const PAGE_META = {
  dashboard: {label:"ダッシュボード", sub:"収支サマリ・グラフ",    color:"#1A3A1A", accent:"#2D7A2D", bg:"#E8F4E8"},
  revenue:   {label:"収入設定",       sub:"売上・案件の入力",       color:"#1A3060", accent:"#2255AA", bg:"#E8EEFF"},
  salary:    {label:"給与・賞与設定",  sub:"経費設定 › 給与・賞与", color:"#3A2000", accent:"#AA7722", bg:"#FFF3DC"},
  transport: {label:"交通費設定",      sub:"経費設定 › 交通費",     color:"#3A2000", accent:"#AA7722", bg:"#FFF3DC"},
  expenses:  {label:"経費設定",        sub:"科目ごとの経費入力",    color:"#3A0010", accent:"#C0392B", bg:"#FDECEA"},
  actuals:   {label:"実績入力",        sub:"売上・経費の実績を記録", color:"#1A1A3A", accent:"#553399", bg:"#F0EEFF"},
  cashflow:  {label:"CFシミュレーター",sub:"入出金タイミングの見える化", color:"#003A3A", accent:"#1A7A7A", bg:"#E0F5F5"},
  loans:     {label:"借入台帳",        sub:"借入・返済の管理",      color:"#001A3A", accent:"#1A5A8A", bg:"#E8F0FA"},
  settings:  {label:"設定",            sub:"会計期間など",          color:"#2A2A2A", accent:"#666",    bg:"#F0F0F0"},
};

export const COMPANIES = {
  FUJIMI: "fujimi",
  LYSIS: "lysis",
};

export const COMPANY_OPTIONS = [
  { id: COMPANIES.FUJIMI, label: "富士見", defaultStartMonth: 5 },
  { id: COMPANIES.LYSIS, label: "Lysis", defaultStartMonth: 5 },
];

export const DEFAULT_COMPANY_ID = COMPANIES.FUJIMI;
export const DEFAULT_START_MONTH = COMPANY_OPTIONS.find((c) => c.id === DEFAULT_COMPANY_ID)?.defaultStartMonth ?? 5;
